import React from 'react';
import Flag from "semantic-ui-react/dist/es/elements/Flag/Flag.js";
import { lowerCase } from "../../../../utils/lower-case";
import { Icon, ICON_NAMES } from "../../../elements/Icon";
import { VALID_FLAG_NAMES } from "./validFlagNames";
export var getIconOrFlag = function getIconOrFlag(country) {
  var flagName = lowerCase(country);
  return flagName && VALID_FLAG_NAMES.includes(flagName) ? React.createElement(Flag, {
    name: flagName
  }) : React.createElement(Icon, {
    name: ICON_NAMES.PHONE,
    size: "small"
  });
};